// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/scene_movie_detail.css
// module id = 81
// module chunks = 0